var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LineChart } from '@tremor/react';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { widgetMetricTableChartTdClass, widgetMetricTableColMetricValueStyle, widgetMetricTableFigureValueSpanClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { TablesDiffColorsConfig, WIDGET_LINE_CHART_GREEN } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { classNames, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { createGetDotColorClass, getBarChartTooltip } from '@web/utility/ tooltip/tremorTooltip';
import { navigateToChartDestination } from '@web/utility/chartNavigation';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ApplicationEnum } from '@workalizer/shared';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { useTranslation } from 'react-i18next';
var metricDiffCol = {
    width: '13%',
    minWidth: '5.25rem'
};
var activeParticipantsCol = {
    width: '1%',
    minWidth: '5.75rem'
};
var topChatSpacesTableColgroup = [
    { width: '14%', minWidth: '10.5rem' },
    { width: '20%', minWidth: '12rem' },
    activeParticipantsCol,
    widgetMetricTableColMetricValueStyle,
    metricDiffCol,
    widgetMetricTableColMetricValueStyle,
    metricDiffCol,
    widgetMetricTableColMetricValueStyle,
    { width: '22%', minWidth: '12rem' }
];
var clickableMetricValueCell = function (id, value, onClick) { return ({
    id: id,
    className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
    render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: onClick }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: value })) }))); }
}); };
var renderContributorList = function (posters, highlightedUserId, onNavigate) {
    if (highlightedUserId === void 0) { highlightedUserId = null; }
    return (_jsx("ul", __assign({ className: "min-w-0 space-y-2" }, { children: posters.map(function (poster) {
            var isHighlighted = highlightedUserId === poster.userId;
            return (_jsxs("li", __assign({ className: "flex min-w-0 cursor-pointer items-start justify-between gap-3", onClick: onNavigate }, { children: [_jsxs("div", __assign({ className: "min-w-0" }, { children: [_jsx("div", __assign({ className: "break-words ".concat(isHighlighted ? 'font-bold' : 'font-semibold') }, { children: poster.name })), poster.department ? (_jsxs("div", __assign({ className: "text-xs text-gray-500" }, { children: ["(", poster.department, ")"] }))) : null] })), _jsx("span", __assign({ className: "".concat(widgetMetricTableFigureValueSpanClass, " pr-4 ").concat(isHighlighted ? 'font-bold' : '') }, { children: poster.posts }))] }), poster.userId));
        }) })));
};
export function TopChatSpaces(_a) {
    var _this = this;
    var _b = _a === void 0 ? {} : _a, userIdProp = _b.userId, orgUnitIdProp = _b.orgUnitId, dateFromProp = _b.dateFrom, dateToProp = _b.dateTo, activityLabelIdProp = _b.activityLabelId;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var filters = useFilters();
    var userId = userIdProp !== null && userIdProp !== void 0 ? userIdProp : filters.user;
    var orgUnitId = orgUnitIdProp !== null && orgUnitIdProp !== void 0 ? orgUnitIdProp : filters.orgUnit;
    var dateFrom = dateFromProp !== null && dateFromProp !== void 0 ? dateFromProp : filters.dateFrom;
    var dateTo = dateToProp !== null && dateToProp !== void 0 ? dateToProp : filters.dateTo;
    var activityLabelId = activityLabelIdProp !== null && activityLabelIdProp !== void 0 ? activityLabelIdProp : filters.activityLabel;
    var navigateToChatEventsLog = function (rangeFrom, rangeTo) {
        navigateToChartDestination({ kind: 'eventsLog', app: ApplicationEnum.CHAT }, {
            navigateTo: navigateTo,
            dateFrom: rangeFrom,
            dateTo: rangeTo,
            userId: userId,
            orgUnitId: orgUnitId
        });
    };
    var _c = trpc.chatRoomsByMessageVolume.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        activityLabelId: activityLabelId
    }), _d = _c.data, topChatSpacesData = _d === void 0 ? [] : _d, isLoading = _c.isLoading, refetch = _c.refetch;
    if (isLoading) {
        return _jsx(Loading, {});
    }
    var volumeTrendSeriesLabel = t('app.apps.chat.topChatSpaces.tablesData.volumeTrend');
    var volumeTrendDotColor = createGetDotColorClass({
        categories: [volumeTrendSeriesLabel],
        colors: [WIDGET_LINE_CHART_GREEN]
    });
    var metricHeaderClass = 'min-w-0 !text-left whitespace-nowrap !align-top leading-tight tracking-normal !px-2';
    var multiLineHeaderClass = 'min-w-0 !text-left !align-top !whitespace-normal leading-tight tracking-normal !px-2';
    var columns = [
        {
            title: t('app.apps.chat.topChatSpaces.tablesData.roomName'),
            isVisible: true,
            className: "".concat(multiLineHeaderClass, " !pl-4")
        },
        {
            title: t('app.apps.chat.topChatSpaces.tablesData.volumeTrend'),
            isVisible: true,
            className: multiLineHeaderClass
        },
        {
            title: (_jsxs("span", __assign({ className: "block whitespace-normal leading-tight" }, { children: [t('app.apps.chat.topChatSpaces.tablesData.activeParticipantsHeaderLine1'), _jsx("br", {}), t('app.apps.chat.topChatSpaces.tablesData.activeParticipantsHeaderLine2')] }))),
            isVisible: true,
            className: "".concat(multiLineHeaderClass, " !min-w-[5.75rem] !pr-3")
        },
        {
            title: t('app.apps.chat.topChatSpaces.tablesData.messages'),
            isVisible: true,
            colspan: 2,
            className: metricHeaderClass
        },
        {
            title: t('app.apps.chat.topChatSpaces.tablesData.reactions'),
            isVisible: true,
            colspan: 2,
            className: metricHeaderClass
        },
        {
            title: t('app.apps.chat.topChatSpaces.tablesData.external'),
            isVisible: true,
            className: metricHeaderClass
        },
        {
            title: t('app.apps.chat.topChatSpaces.tablesData.topPosters'),
            isVisible: true,
            className: "".concat(multiLineHeaderClass, " !pr-4")
        }
    ];
    var navigateToPeriodChatEventsLog = function () {
        return navigateToChatEventsLog(dateFrom, dateTo);
    };
    var data = topChatSpacesData.map(function (item) { return [
        {
            id: "room-".concat(item.roomId),
            className: classNames(widgetMetricTablePrimaryLabelTdClass, 'cursor-pointer'),
            render: function () { return (_jsx("div", __assign({ className: "min-w-0 max-w-full cursor-pointer font-semibold break-words", onClick: navigateToPeriodChatEventsLog }, { children: item.roomName }))); }
        },
        {
            id: "volume-trend-".concat(item.roomId),
            className: widgetMetricTableChartTdClass,
            render: function () { return (_jsx("div", __assign({ className: "min-w-[12rem] w-full max-w-none cursor-pointer" }, { children: _jsx(LineChart, { data: item.volumeTrend.map(function (d) {
                        var _a;
                        return (_a = {
                                date: d.date
                            },
                            _a[volumeTrendSeriesLabel] = d.value,
                            _a);
                    }), index: "date", categories: [volumeTrendSeriesLabel], colors: [WIDGET_LINE_CHART_GREEN], curveType: "monotone", showLegend: false, showYAxis: false, showXAxis: false, startEndOnly: true, className: "h-20 min-h-[4.5rem] w-full pb-6", customTooltip: function (props) {
                        return getBarChartTooltip(props, [volumeTrendSeriesLabel], {
                            getDotColorClass: volumeTrendDotColor,
                            referenceDateFrom: dateFrom,
                            referenceDateTo: dateTo
                        });
                    }, onValueChange: function (event) {
                        var day = event === null || event === void 0 ? void 0 : event.date;
                        if (typeof day === 'string' && day) {
                            navigateToChatEventsLog(day, day);
                        }
                    } }) }))); }
        },
        clickableMetricValueCell("active-participants-".concat(item.roomId), item.activeParticipants, navigateToPeriodChatEventsLog),
        clickableMetricValueCell("messages-value-".concat(item.roomId), item.messages, navigateToPeriodChatEventsLog),
        metricTablePeriodDiffRowCell("messages-diff-".concat(item.roomId), item.prevMessages, TablesDiffColorsConfig.GREEN),
        clickableMetricValueCell("reactions-value-".concat(item.roomId), item.reactions, navigateToPeriodChatEventsLog),
        metricTablePeriodDiffRowCell("reactions-diff-".concat(item.roomId), item.prevReactions, TablesDiffColorsConfig.GREEN),
        clickableMetricValueCell("external-".concat(item.roomId), "".concat(item.externalPercent, "%"), navigateToPeriodChatEventsLog),
        {
            id: "top-posters-".concat(item.roomId),
            className: "".concat(widgetMetricTablePrimaryLabelTdClass, " !pr-4"),
            render: function () {
                return renderContributorList(item.topPosters, userId, navigateToPeriodChatEventsLog);
            }
        }
    ]; });
    var titleKey = 'app.apps.chat.topChatSpaces.title';
    var descriptionKey = 'widgetTitleDescriptions.apps.topChatSpaces';
    return (_jsxs("div", __assign({ className: "w-full min-w-0" }, { children: [_jsx(WidgetTitle, { title: t(titleKey), description: descriptionKey, insightType: InsightTypeEnum.chatRoomsByMessageVolume, insightsData: topChatSpacesData, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t(titleKey), onExportHandler: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, topChatSpacesData.map(function (item) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('app.apps.chat.topChatSpaces.tablesData.roomName')] = item.roomName,
                                        _a[t('app.apps.chat.topChatSpaces.tablesData.activeParticipants')] = item.activeParticipants,
                                        _a[t('app.apps.chat.topChatSpaces.tablesData.messages')] = item.messages,
                                        _a[t('app.apps.chat.topChatSpaces.tablesData.reactions')] = item.reactions,
                                        _a[t('app.apps.chat.topChatSpaces.tablesData.external')] = "".concat(item.externalPercent, "%"),
                                        _a[t('app.apps.chat.topChatSpaces.tablesData.topPosters')] = item.topPosters
                                            .map(function (poster) {
                                            return poster.department
                                                ? "".concat(poster.name, " (").concat(poster.department, "): ").concat(poster.posts)
                                                : "".concat(poster.name, ": ").concat(poster.posts);
                                        })
                                            .join('; '),
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(topChatSpacesData) }) }), _jsx(Table, { columns: columns, data: isInsightsDataEmpty(topChatSpacesData) ? [] : data, columnColStyles: topChatSpacesTableColgroup, columnsClassName: "[&_th]:!align-top [&_th]:!pb-5", tableClassName: classNames('w-full table-auto', 'min-w-[72rem]'), rowClassName: "[&>td]:align-top [&:first-child>td]:!pt-5" })] })));
}
